import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../service/app.service';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './auth-layout.html',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
    ],
})
export class AuthLayout implements OnInit, OnDestroy {
    private readonly service = inject(AppService);
    readonly store = this.service.indexState;

    showTopButton = false;
    constructor(public storeData: Store<any>) {}
    headerClass = '';
    ngOnInit() {
        this.toggleLoader();
        globalThis.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    ngOnDestroy() {
        globalThis.removeEventListener('scroll', () => {});
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
